export const coursesIcon = `
<svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_583_2591)"> 
<path d="M13.9994 4.73109L24.0282 10.5169L14.5435 16.2077C13.5934 16.7777 12.4066 16.7777 11.4565 16.2077L1.97182 10.5169L12.0006 4.73109C12.6191 4.37425 13.3809 4.37425 13.9994 4.73109Z" stroke="currentColor" stroke-width="2"/>
<path d="M7 13V19" stroke="currentColor" stroke-width="2"/>
<path d="M19 13V19" stroke="currentColor" stroke-width="2"/>
<path d="M23 10V16" stroke="currentColor" stroke-width="2"/>
<path d="M19 19C19 20.6569 16.3137 22 13 22C9.68629 22 7 20.6569 7 19" stroke="currentColor" stroke-width="2"/>
<circle cx="23" cy="17" r="1" stroke="currentColor" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_583_2591">
<rect width="26" height="26" fill="white"/>
</clipPath>
</defs>
</svg>
`;
